import { useKey } from 'react-use';

type CallbackArrow = (key: string) => void;
type Callback = () => void;

export function useArrows(callback: CallbackArrow, depArray: any[] = []) {
  useKey(
    'ArrowDown',
    (event) => {
      event.preventDefault();
      callback('ArrowDown');
    },
    {
      event: 'keydown',
    },
    [...depArray]
  );

  useKey(
    'ArrowUp',
    (event) => {
      event.preventDefault();
      callback('ArrowUp');
    },
    {
      event: 'keydown',
    },
    [...depArray]
  );
}

export function useEnter(callback: Callback, depArray: any[] = []) {
  useKey(
    'Enter',
    (event) => {
      event.preventDefault();
      callback();
    },
    {
      event: 'keydown',
    },
    [...depArray]
  );
}
